import React, { createContext, useContext, useState, useCallback, useMemo, startTransition } from 'react';
import { v4 as uuidv4 } from 'uuid';
import ToastComponent from '../components/Toast'; // The actual Toast component

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 5000) => {
    const id = uuidv4();
    startTransition(() => {
      setToasts(prevToasts => [
        ...prevToasts,
        { id, message, type, duration }
      ]);
    });

    setTimeout(() => {
      removeToast(id);
    }, duration);
  }, []);

  const removeToast = useCallback((id) => {
    startTransition(() => {
      setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
    });
  }, []);

  const toast = useMemo(() => ({
    success: (message, duration) => addToast(message, 'success', duration),
    error: (message, duration) => addToast(message, 'error', duration),
    warning: (message, duration) => addToast(message, 'warning', duration),
    info: (message, duration) => addToast(message, 'info', duration),
    add: addToast, // Generic add method
  }), [addToast]);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="toast-container">
        {toasts.map(t => (
          <ToastComponent
            key={t.id}
            message={t.message}
            type={t.type}
            onClose={() => removeToast(t.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
